import { useFormContext } from "react-hook-form";
import { InputProps } from "../../../../../types/Form";
import { HookInputBaseProps } from "../../types";
import { FileInputField } from "./FileInputField";

export interface HookFileInputProps
  extends Omit<InputProps, "type">,
    HookInputBaseProps {
  onFileRemove?: (fileIndex: number) => void;
}

export const HookFileInput = (props: HookFileInputProps) => {
  const { control, watch, setValue, trigger } = useFormContext();

  return (
    <FileInputField {...props} {...{ control, watch, setValue, trigger }} />
  );
};
